import React from 'react'
import { useCreateMap, useInitMapOnClick } from '../hooks'

interface MapProps {
  children?: React.ReactNode | React.ReactNode[] | null,
}

const Map: React.FC<MapProps> = ({ children }) => {
  useCreateMap('map')
  useInitMapOnClick()

  return (
    <div id={`map`} className="map">
      {children}
    </div>
  )
}

export default Map
